import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import Container from "react-bootstrap/esm/Container";
import { Globals } from "../globals";

export default function Datenschutz() {
    const { t } = useTranslation();

    return (
        <Container className="py-4">
            <h1>{t('footer.privacy')}</h1>
            <p className="text-muted">{t('legal.lastUpdated')}: 10.10.2026</p>

            <h2 className="h4 mt-4">{t('legal.privacy.section1Title')}</h2>
            <p>
                {t('legal.privacy.section1Text1')}
            </p>
            <p>
                <strong>{t('legal.privacy.responsible')}</strong><br />
                Johann Wiebe<br />
                E-Mail: <a href={`mailto:${Globals.ADMIN_EMAIL}`}>{Globals.ADMIN_EMAIL}</a><br />
                Website: <a href={Globals.URL}>{Globals.URL.replace("https://", "")}</a>
            </p>

            <h2 className="h4 mt-4">{t('legal.privacy.section2Title')}</h2>
            <p>{t('legal.privacy.section2Text1')}</p>
            <ul>
                <li>{t('legal.privacy.dataEmail')}</li>
                <li>{t('legal.privacy.dataGoogle')}</li>
                <li>{t('legal.privacy.dataSermons')}</li>
                <li>{t('legal.privacy.dataServices')}</li>
                <li>{t('legal.privacy.dataChoirSongs')}</li>
                <li>{t('legal.privacy.dataPreachers')}</li>
                <li>{t('legal.privacy.dataConductor')}</li>
                <li>{t('legal.privacy.dataDeliveryLog')}</li>
                <li>{t('legal.privacy.dataSelfService')}</li>
                <li>{t('legal.privacy.dataPushTokens')}</li>
            </ul>
            <p>{t('legal.privacy.section2Text2')}</p>
            <p>{t('legal.privacy.section2Text3')}</p>

            <h3 className="h5 mt-3">{t('legal.privacy.remindersTitle')}</h3>
            <p>{t('legal.privacy.remindersText')}</p>
            <p>{t('legal.privacy.consentText')}</p>

            <h3 className="h5 mt-3">{t('legal.privacy.personalLinkTitle')}</h3>
            <p>{t('legal.privacy.personalLinkText1')}</p>
            <p>{t('legal.privacy.personalLinkText2')}</p>
            <p>{t('legal.privacy.personalLinkText3')}</p>

            <h2 className="h4 mt-4">{t('legal.privacy.section3Title')}</h2>
            <p>{t('legal.privacy.section3Text')}</p>

            <h2 className="h4 mt-4">{t('legal.privacy.section4Title')}</h2>
            <p>{t('legal.privacy.section4Text')}</p>
            <p>{t('legal.privacy.section4Text2')}</p>

            <h2 className="h4 mt-4">{t('legal.privacy.section5Title')}</h2>
            <p>{t('legal.privacy.section5Text1')}</p>
            <p>
                {t('legal.privacy.googlePrivacyPolicy')}:{' '}
                <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
                    https://policies.google.com/privacy
                </a>
            </p>
            <p>
                {t('legal.privacy.firebaseInfo')}:{' '}
                <a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer">
                    https://firebase.google.com/support/privacy
                </a>
            </p>

            <h3 className="h5 mt-3">{t('legal.privacy.processorsTitle')}</h3>
            <p>{t('legal.privacy.processorsText')}</p>
            <ul>
                <li>
                    {t('legal.privacy.processorBrevo')}{' '}
                    <a href="https://www.brevo.com/de/legal/privacypolicy/" target="_blank" rel="noopener noreferrer">
                        {t('legal.privacy.processorPrivacyLink')}
                    </a>
                </li>
                <li>
                    {t('legal.privacy.processorMeta')}{' '}
                    <a href="https://www.whatsapp.com/legal/business-data-processing-terms" target="_blank" rel="noopener noreferrer">
                        {t('legal.privacy.processorPrivacyLink')}
                    </a>
                </li>
                <li>
                    {t('legal.privacy.processorCloudflare')}{' '}
                    <a href="https://www.cloudflare.com/de-de/privacypolicy/" target="_blank" rel="noopener noreferrer">
                        {t('legal.privacy.processorPrivacyLink')}
                    </a>
                </li>
            </ul>
            <p>{t('legal.privacy.processorsTransfer')}</p>

            <h2 className="h4 mt-4">{t('legal.privacy.section6Title')}</h2>
            <p>{t('legal.privacy.section6Text')}</p>
            <ul>
                <li>{t('legal.privacy.retentionTokens')}</li>
                <li>{t('legal.privacy.retentionLog')}</li>
                <li>{t('legal.privacy.retentionAccess')}</li>
                <li>{t('legal.privacy.retentionCounters')}</li>
                <li>{t('legal.privacy.retentionPreachers')}</li>
                <li>{t('legal.privacy.retentionAbsences')}</li>
                <li>{t('legal.privacy.retentionDeletionRequests')}</li>
            </ul>

            <h2 className="h4 mt-4">{t('legal.privacy.section7Title')}</h2>
            <p>{t('legal.privacy.section7Text')}</p>
            <ul>
                <li>{t('legal.privacy.rightAccess')}</li>
                <li>{t('legal.privacy.rightCorrection')}</li>
                <li>{t('legal.privacy.rightDeletion')}</li>
                <li>{t('legal.privacy.rightRestriction')}</li>
                <li>{t('legal.privacy.rightPortability')}</li>
                <li>{t('legal.privacy.rightObjection')}</li>
                <li>{t('legal.privacy.rightComplaint')}</li>
            </ul>
            <p>
                {t('legal.privacy.contactForRights')}: <a href={`mailto:${Globals.ADMIN_EMAIL}`}>{Globals.ADMIN_EMAIL}</a>
            </p>
            <p>
                {t('legal.privacy.deletionRequestText')}{" "}
                <Link to={Globals.PATH_DATA_DELETION_REQUEST}>
                    {t('legal.privacy.deletionRequestLink')}
                </Link>
            </p>
        </Container>
    );
}
